import PromotionRegisterContainer from './PromotionRegisterContainer';
export default PromotionRegisterContainer;
